let AgentLevel = {
  EXECUTIVE: 'EXECUTIVE',
  SILVER: 'SILVER',
  GOLD: 'GOLD',
  PLATINUM: 'PLATINUM'
}

export { AgentLevel }
